export default __webpack_public_path__ + "static/first-gamers-video-91814b1ce3667b61cebeb8a2746a1c34.png";